<template>
  <el-form ref="form" :model="formData" size="small" :rules="rules">
    <el-row>
      <el-form-item
        :label="$l('form_label_fileType') || '文件类型'"
        prop="fileType"
      >
        <dict-select
          size="small"
          clearable
          filterable
          v-model="formData.fileType"
          :body="fileTypeParams"
          url="/sys/common/dict/system"
        ></dict-select>
      </el-form-item>
      <el-form-item :label="$l('form_label_remark') || '备注说明'">
        <el-input
          v-model="formData.remark"
          :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
          type="textarea"
          :maxlength="250"
          show-word-limit
        >
        </el-input>
      </el-form-item>
    </el-row>
    <el-row>
      <el-upload
        action="#"
        multiple
        drag
        :file-list="listFile"
        :auto-upload="false"
        :limit="uploadLimit"
        :on-exceed="onFileExceed"
        :on-change="onFileChange"
        :on-remove="onFileChange"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          {{ $l('INDEX.file_upload_tips_first') || '将文件拖到此处，或' }}
          <em>{{ $l('INDEX.file_upload_tips_last') || '点击上传' }}</em>
        </div>
      </el-upload>
    </el-row>
  </el-form>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  props: { uploadLimit: { type: Number, default: 10 } },
  data() {
    return {
      fileTypeParams: { dictType: 'customerFileType' },
      formData: {},
      listFile: [],
      rules: {
        fileType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    onFileChange(file, fileList) {
      this.listFile = fileList
    },
    onFileExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.uploadLimit} 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      )
    },
    async upload() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return false

      if (!this.listFile || !this.listFile.length) {
        this.$message({
          message: this.$l('INDEX.tips_choose_statement_doc') || '请选择文件',
          type: 'warning',
        })
        return false
      }
      // 如果是盖章，判断图片类型
      if (this.formData.fileType.indexOf('-seal') >= 0) {
        const legalImg = [
          'JPEG',
          'TIFF',
          'PNG',
          'GIF',
          'PSD',
          'RAW',
          'EPS',
          'SVG',
        ]

        for (const file of this.listFile) {
          const { name } = file
          const fileSuffix = name
            .substring(name.lastIndexOf('.') + 1)
            .toLocaleUpperCase()

          if (!legalImg.includes(fileSuffix)) {
            this.$message.error(
              `该文件类型下仅支持上传图片(${legalImg.join()})`
            )
            return
          }
        }
      }

      const listFile = await this.uploadFiles()
      if (!listFile || !listFile.length) {
        this.$message({
          message: '文件上传失败',
          type: 'warning',
        })
        return false
      }
      if (listFile.length !== listFile.filter(Boolean).length) {
        this.$message({
          message: '文件上传失败',
          type: 'warning',
        })
        return false
      }
      return { listFile, ...this.formData }
    },
    uploadFiles() {
      if (!this.listFile || !this.listFile.length) return Promise.resolve([])
      const uploadTask = this.listFile.map((file) => {
        return this.$api
          .SYS_UPLOAD(file.raw)
          .then((res) => ({
            fileCode: res.body.fileId,
            fileUrl: res.body.url,
            fileName: file.name,
          }))
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },
  },
}
</script>
<style lang="scss" scoped>
// 重写element 样式
::v-deep {
  .el-upload-dragger {
    width: 478px;
  }
}
</style>
